module.exports = __webpack_public_path__ + "img/logo_ucc.af80718d.png";